import React from 'react';
import Icon from '../../../components/AppIcon';


const ConnectionStatusDashboard = ({
  connections,
  syncStats,
  selectedConnection,
  onConnectionSelect,
  onTestConnection
}) => {
  const connectedCount = connections?.filter(c => c?.connectionStatus === 'connected')?.length || 0;
  const totalSyncs = syncStats?.totalSyncs || 0;
  const successRate = syncStats?.totalSyncs > 0
    ? ((syncStats?.successfulSyncs / syncStats?.totalSyncs) * 100)?.toFixed(1)
    : 0;
  const totalRecords = syncStats?.totalRecordsProcessed || 0;

  const stats = [
    {
      label: 'Connected Systems',
      value: `${connectedCount}/${connections?.length}`,
      icon: 'Link',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Total Syncs',
      value: totalSyncs,
      icon: 'RefreshCw',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Success Rate',
      value: `${successRate}%`,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Records Processed',
      value: totalRecords?.toLocaleString(),
      icon: 'Database',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-5">
          <div className="flex items-center justify-between mb-3">
            <div className={`${stat?.bgColor} ${stat?.color} p-3 rounded-lg`}>
              <Icon name={stat?.icon} size={24} />
            </div>
          </div>
          <div className="text-2xl font-bold text-foreground mb-1">{stat?.value}</div>
          <div className="text-sm text-muted-foreground">{stat?.label}</div>
        </div>
      ))}
    </div>
  );
};

export default ConnectionStatusDashboard;
